<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="exam">
    <!--   CountDown Timer     -->
    <exam-countdown
      :duration="durationMilliseconds"
      :start-time="startTimeStamp"
      :auto-start="true"
      @countDownFinished="finishExam"
    >
      <template v-slot:default="props">
        <progress-bar
          :min="0"
          :max="durationMilliseconds"
          :value="props.calc.passedTime"
          :label="
            ('0' + props.calc.hours).slice(-2) +
              ':' +
              ('0' + props.calc.minutes).slice(-2) +
              ':' +
              ('0' + props.calc.seconds).slice(-2)
          "
          :reversed="true"
          :external_class="{
            orange: props.calc.minutes < 10,
            red: props.calc.minutes < 2
          }"
        ></progress-bar>
      </template>
    </exam-countdown>

    <!--  Question Numbers table       -->
    <p @click="showNavigationTable = !showNavigationTable" class="nav-table">
      <span v-if="!showNavigationTable" class="cs-expand">+</span>
      <span v-if="showNavigationTable" class="cs-collapse">-</span>
      <span>Navigation Table</span>
    </p>

    <div v-if="showNavigationTable" class="question-numbers">
      <span v-for="(q, index) in questions" :key="index">
        <span
          :class="questionNumberClass(index)"
          @click="changeQuestion(index)"
          :key="index"
          v-text="index + 1 < 10 ? '0' + (index + 1) : index + 1"
        ></span>
      </span>
    </div>

    <div id="connection_error" class="connection-error" style="display: none;">
      <p>
        Warning: weak Internet connection - some of your answers may not be saved while the connection is
        weak.
      </p>
    </div>

    <!--   Questions and Choices     -->
    <ul class="questions">
      <template v-for="(question, q_index) in questions">
        <li v-if="q_index === current_question_index && artificialLoading === false" :key="q_index">
          <div class="title" v-html="marked(q_index + 1 + '- ' + question.problem_title)"></div>

          <div
            :lang="target_language.lang"
            v-if="show_translations"
            class="translated-title"
            v-html="translatedQuestion"
          ></div>

          <div class="choices">
            <div v-if="question.have_multiple_choices">
              <div class="choice" v-for="(choice, c_index) in question.choices" :key="c_index">
                <label :for="'choice' + q_index + c_index">
                  <input
                    type="checkbox"
                    :checked="choice.is_chosen === 1 ? true : false"
                    @click="
                      updateCheckboxChoice({
                        choice_id: choice.choice_id,
                        question_index: q_index,
                        choice_index: c_index,
                        checked: $event.target.checked
                      })
                    "
                    :id="'choice' + q_index + c_index"
                  />

                  <span
                    class="choice-title"
                    v-html="marked(alphabets[c_index] + '. ' + choice.choice_title)"
                  ></span>

                  <div
                    :lang="target_language.lang"
                    class="translated-choice-title"
                    v-if="show_translations"
                    v-html="translatedChoice(c_index)"
                  ></div>
                </label>
              </div>
            </div>
            <div v-else>
              <div class="choice" v-for="(choice, c_index) in question.choices" :key="c_index">
                <label :for="'choice' + q_index + c_index">
                  <!--  :name attribute is necessary here because otherwise selecting multiple radios for a question is possible wich is not desirable-->
                  <input
                    @click="
                      updateRadioChoice({
                        question_index: q_index,
                        choice_index: c_index
                      })
                    "
                    type="radio"
                    :checked="choice.is_chosen === 1 ? true : false"
                    :id="'choice' + q_index + c_index"
                    :name="'question_' + q_index"
                  />
                  <span
                    class="choice-title"
                    v-html="marked(alphabets[c_index] + '. ' + choice.choice_title)"
                  ></span>

                  <div
                    :lang="target_language.lang"
                    class="translated-choice-title"
                    v-if="show_translations"
                    v-html="translatedChoice(c_index)"
                  ></div>
                </label>
              </div>
            </div>
          </div>

          <!--  Flag input -->
          <div class="mt-3 flagQuestion">
            <label :for="'flag' + q_index">
              <input
                :id="'flag' + q_index"
                type="checkbox"
                :checked="question.is_flagged === 1 ? true : false"
                @change="
                  updateQuestionFlag({
                    question_id: question.question_id,
                    checked: $event.target.checked,
                    question_index: q_index
                  })
                "
              />
              <span>Flag this question for review</span>
            </label>
          </div>
        </li>
      </template>
    </ul>

    <div v-show="artificialLoading" :class="{ artificialLalLoader: artificialLoading }">
      <p class="title">Artificial Lag</p>
      <p class="subTitle">
        You can change this option when starting a new exam.
      </p>
    </div>

    <!--  Next, Preview, Finish  Buttons    -->
    <div class="buttons">
      <button @click="previous" :class="{ disabled: isFirstQuestion }" :disabled="isFirstQuestion">
        Previous
      </button>
      <button @click="next" :class="{ disabled: isLastQuestion }" :disabled="isLastQuestion">
        Next
      </button>
      <button @click="finishWithConfirm()" class="toright" :class="{ highlighted: isLastQuestion }">
        Finish
      </button>
      <div class="clearfix"></div>
    </div>

    <GoogleTranslate
      v-if="exam_details.machine_translation"
      :current-question-index="current_question_index"
    />

    <video id="invigilate_webcam_video" style="display: none;"></video>
    <video id="invigilate_screen_video" style="display: none;"></video>

    <canvas id="invigilate_screen_canvas" style="display: none;"></canvas>
    <canvas id="invigilate_webcam_canvas" style="display: none;"></canvas>
  </div>
</template>

<script>
import ProgressBar from '../Common/ProgressBar'
import ExamCountdown from '../Common/ExamCountDown'
import GoogleTranslate from './GoogleTranslate'
import { mapState, mapActions, mapGetters } from 'vuex'
import ENV from '../../env'
import axios from 'axios'

export default {
  data() {
    return {
      current_question_index: 0,
      artificialLoading: false,
      showNavigationTable: false
    }
  },
  components: {
    ProgressBar,
    ExamCountdown,
    GoogleTranslate
  },

  computed: {
    ...mapState(['user_id', 'exam_id']),
    ...mapState('exam', ['questions', 'exam_details']),
    ...mapState('invigilate', [
      'webcam_stream',
      'screen_recorder_stream',
      'audio_stream',
      'stop_audio_recording'
    ]),
    ...mapState(['user_id', 'exam_id', 'artificial_type', 'alphabets', 'usage_threshold_level']),
    ...mapState('googleTranslate', ['show_translations', 'target_language']),
    ...mapGetters('googleTranslate', ['translatedQuestion', 'translatedChoice']),
    ...mapGetters('invigilate', ['examInvigilateFulfilled']),
    ...mapGetters(['examIsInvigilated']),
    // turn exam duration in to milliseconds
    durationMilliseconds() {
      return this.exam_details.duration * 60 * 1000
    },

    // every time exam component loads
    // get start time from backend
    // so when user refresh the page, or login
    // from another session, timer syncs with backend
    startTimeStamp() {
      return this.exam_details.start_datetime
    },

    isLastQuestion() {
      return this.current_question_index === this.questions.length - 1
    },
    isFirstQuestion() {
      return this.current_question_index === 0
    }
  },

  methods: {
    ...mapActions('exam', ['updateQuestionFlag', 'updateCheckboxChoice', 'updateRadioChoice', 'finishExam']),

    finishWithConfirm() {
      if (confirm('Are you sure you want to finish the exam?')) {
        this.finishExam()
      }
    },

    changeQuestion(index) {
      this.$store.dispatch('googleTranslate/clear')
      this.applyArtificialLag(() => {
        this.current_question_index = index
      })
    },
    previous() {
      this.$store.dispatch('googleTranslate/clear')
      this.applyArtificialLag(() => {
        if (this.current_question_index > 0) this.current_question_index--
      })
    },

    next() {
      this.$store.dispatch('googleTranslate/clear')
      this.applyArtificialLag(() => {
        if (this.current_question_index < this.questions.length - 1) this.current_question_index++
      })
    },

    applyArtificialLag(callback) {
      if (
        this.exam_details.is_simulation &&
        this.exam_details.artificial_lag &&
        this.artificial_type !== 'no_lag'
      ) {
        this.artificialLoading = true

        setTimeout(() => {
          callback()
          this.artificialLoading = false
        }, this.randomArtificialLagTime())
      } else {
        callback()
      }
    },

    randomArtificialLagTime() {
      let lagTime = 1000
      // generate  a random number between 2000 and 3000 milliseconds
      if (this.artificial_type === 'normal') {
        lagTime = (Math.random() * 1.2 + 0.3) * 1000
      }

      // generate  a random number between 5000 and 11000 milliseconds
      if (this.artificial_type === 'large') {
        lagTime = (Math.random() * 3.5 + 1.5) * 1000
      }

      return lagTime
    },

    // calculate css class for every question number
    questionNumberClass(index) {
      let result = 'item'
      if (index === this.current_question_index) {
        result += ' active'
      }

      let q = this.questions[index]
      if (q.is_flagged) {
        result += ' flagged'
      }

      let chosen_class = ''
      q.choices.forEach((choice) => {
        if (choice.is_chosen) {
          chosen_class = ' chosen'
        }
      })

      result += chosen_class

      return result
    },

    handleKeyDown(event) {
      const key = event.key // "ArrowRight", "ArrowLeft", "ArrowUp", or "ArrowDown"
      if (key === 'ArrowRight' || key === 'k' || key === 'd') {
        this.next()
      }
      if (key === 'ArrowLeft' || key === 'j' || key === 'a') {
        this.previous()
      }
    },

    recordAudio() {
      if (this.exam_details.invigilated && this.examInvigilateFulfilled) {
        let mediaRecorder = new MediaRecorder(this.audio_stream)
        console.log('this.audio_streamxxxxxxxx')
        console.log(this.audio_stream)
        let recordedChunks = []
        mediaRecorder.ondataavailable = (event) => {
          console.log('data-available')
          if (event.data.size > 0) {
            recordedChunks.push(event.data)
          } else {
            // ...
          }
        }

        mediaRecorder.addEventListener('stop', () => {
          const audioBlob = new Blob(recordedChunks)
          console.log('audioBlobxxxxxxx')
          console.log(audioBlob)

          let fd = new FormData()
          fd.append('audio', audioBlob, 'audio.wav')
          fd.append('user_id', this.user_id)
          fd.append('start_time', startTimeStamp)
          console.log('AUDIOOOOOOOOOOOOOOOOOOOO')
          console.log(parseInt(this.exam_details.start_datetime / 1000))
          fd.append('exam_start_datetime', parseInt(this.exam_details.start_datetime / 1000))
          fd.append('exam_id', this.exam_id)
          axios.post(ENV.invigilate.api_url + 'store-audio', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })

          if (!this.stop_audio_recording) {
            setTimeout(() => {
              this.recordAudio()
            }, ENV.invigilate.audio_record_interval)
          }
        })

        let startTimeStamp = parseInt(Date.now() / 1000)
        mediaRecorder.start()

        setTimeout(() => {
          mediaRecorder.stop()
        }, ENV.invigilate.audio_record_duration)
      }
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)

    // a polyfill for microsoft Edge to support canvas "toBlob" function
    // TODO: transfer this to a pollyfils.js file and load it globally
    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function(callback, type, quality) {
          var canvas = this
          setTimeout(function() {
            var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
              len = binStr.length,
              arr = new Uint8Array(len)

            for (var i = 0; i < len; i++) {
              arr[i] = binStr.charCodeAt(i)
            }

            callback(new Blob([arr], { type: type || 'image/png' }))
          })
        }
      })
    }

    // TODO: add does not support error for webcam and screen recorder
    // if (!navigator.getDisplayMedia && !navigator.mediaDevices.getDisplayMedia) {
    //         var error = 'Your browser does NOT supports getDisplayMedia API.'
    //         document.querySelector('h1').innerHTML = error
    //         document.querySelector('h1').style.color = 'red'

    //         document.querySelector('video').style.display = 'none'
    //         button.style.display = 'none'
    //         throw new Error(error)
    //       }

    //  show setup page if webcam is not working
    if (this.examIsInvigilated && !this.examInvigilateFulfilled) {
      this.$store.dispatch('invigilate/showInvigilateSetup')
    }

    // take WEBCAM  picture every X seconds
    if (this.examIsInvigilated && this.examInvigilateFulfilled) {
      let vid = document.getElementById('invigilate_webcam_video')

      vid.srcObject = this.webcam_stream
      vid
        .play()
        .then(() => {
          let webcam_interval = setInterval(() => {
            // const canvas = document.createElement('canvas') // create a canvas
            const canvas = document.getElementById('invigilate_webcam_canvas') // create a canvas
            const ctx = canvas.getContext('2d') // get its context
            canvas.width = vid.videoWidth // set its size to the one of the video
            canvas.height = vid.videoHeight
            ctx.drawImage(vid, 0, 0) // the video
            let captureTimeStamp = parseInt(Date.now() / 1000)
            return new Promise((res) => {
              canvas.toBlob(res, 'image/jpeg') // request a Blob from the canvas
            })
              .then((blob) => {
                console.log('blob')
                console.log(blob)
                let fd = new FormData()
                fd.append('image', blob, 'webcam.jpg')
                fd.append('user_id', this.user_id)
                fd.append('capture_time', captureTimeStamp)
                fd.append('exam_start_datetime', parseInt(this.exam_details.start_datetime / 1000))
                console.log('WEBCAMMMMM')
                console.log(parseInt(this.exam_details.start_datetime / 1000))
                fd.append('type', 'webcam')
                fd.append('exam_id', this.exam_id)
                axios.post(ENV.invigilate.api_url + 'store-image', fd, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                })
              })
              .catch((err) => {
                console.log('error converting canvas to blob')
                console.log(err)
                this.$store.dispatch('invigilate/showInvigilateSetup')
              })
          }, ENV.invigilate.webcam_snapshot_interval)

          this.$store.dispatch('invigilate/setWebcamIntervalID', webcam_interval)
        })
        .catch((err) => {
          console.log('error playing webcam video')
          console.log(err)
          this.$store.dispatch('invigilate/showInvigilateSetup')
        })
    }

    // take SCREEN picture every X seconds
    if (this.examIsInvigilated && this.examInvigilateFulfilled) {
      let screen_vid = document.getElementById('invigilate_screen_video')

      screen_vid.srcObject = this.screen_recorder_stream
      screen_vid
        .play()
        .then(() => {
          let screen_recorder_interval = setInterval(() => {
            // const canvas2 = document.createElement('canvas') // create a canvas
            const canvas2 = document.getElementById('invigilate_screen_canvas')
            console.log('canvas2')
            console.log(canvas2)

            const ctx = canvas2.getContext('2d') // get its context
            canvas2.width = screen_vid.videoWidth // set its size to the one of the video
            canvas2.height = screen_vid.videoHeight
            ctx.drawImage(screen_vid, 0, 0) // the video
            let captureTimeStamp = parseInt(Date.now() / 1000)
            return new Promise((res) => {
              canvas2.toBlob(res, 'image/jpeg') // request a Blob from the canvas
            })
              .then((blob) => {
                console.log('screen blob')
                console.log(blob)
                let fd = new FormData()
                fd.append('image', blob, 'screen.jpg')
                fd.append('user_id', this.user_id)
                fd.append('capture_time', captureTimeStamp)
                console.log('SCREENNNNNNNN')
                console.log(parseInt(this.exam_details.start_datetime / 1000))
                fd.append('exam_start_datetime', parseInt(this.exam_details.start_datetime / 1000))
                fd.append('exam_id', this.exam_id)
                fd.append('type', 'screen')
                axios.post(ENV.invigilate.api_url + 'store-image', fd, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                })
              })
              .catch((err) => {
                console.log('error converting screen recorder canvas to blob')
                console.log(err)
                // TODO: dispatch change screen_recorder_status to unknow error
                this.$store.dispatch('invigilate/showInvigilateSetup')
              })
          }, ENV.invigilate.screen_snapshot_interval)

          this.$store.dispatch('invigilate/setScreenIntervalID', screen_recorder_interval)
        })
        .catch((err) => {
          console.log('error playing webcam video')
          console.log(err)
          // TODO: dispatch change screen_recorder_status to unknow error
          this.$store.dispatch('invigilate/showInvigilateSetup')
        })
    }

    this.recordAudio()
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }
}
</script>
